<template>
  <div>
    <div class="css-grid pay-invoice-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cardholderName" placeholder="Card Holder Name"></StoreConnectedInput>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--7">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cardNumber" :debounce="false" placeholder="Credit Card Number"></StoreConnectedInput>
          </div>
        </div>
        <div class="grid__col--2--half">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="expDate" :debounce="false" placeholder="MM/YY"></StoreConnectedInput>
          </div>
        </div>
        <div class="grid__col--2--half">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cvv" :debounce="false" placeholder="CVV"></StoreConnectedInput>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="street" :debounce="false" placeholder="Billing Address"></StoreConnectedInput>
      </div>
      <div class="h-collapsible"></div>
    </div>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--8">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="city" :debounce="false" placeholder="City"></StoreConnectedInput>
          </div>
        </div>
        <div class="grid__col--2">
          <div class="form__item--row">
            <StoreConnectedSelect :store="store" :action="action" :options="states" name="billingInfo" sub-prop="state" placeholder="State"></StoreConnectedSelect>
          </div>
        </div>
        <div class="grid__col--2">
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="zip" :debounce="false" placeholder="Zip Code"></StoreConnectedInput>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
  </div>
</template>

<script>
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../../form-items/StoreConnectedInput.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditCardForm',
    components: {
      StoreConnectedInput,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'payInvoice',
        action: 'setObjectProperty',
      };
    },
    computed: {
      ...mapGetters('batteryStore', ['states']),
    }
  };
</script>
